"use client";

import { useEffect, useRef, useState } from "react";
import "./Hero.css";
import can1 from "../assets/hero/black_can_hero.png";
import can2 from "../assets/hero/black_can_hero_rotated.png";
import can3 from "../assets/hero/black_can_hero_rotated_2.png";
import image1 from "../assets/hero/1.jpg";
import image2 from "../assets/hero/2.jpg";
import image3 from "../assets/hero/3.jpg";
import image4 from "../assets/hero/4.jpg";

const Hero = () => {
  const images = [image1, image2, image3, image4];

  const canvasRef = useRef(null);

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // 3 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let animationFrameId;

    // Set canvas dimensions
    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    // Particle class
    class Particle {
      constructor() {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.size = Math.random() * 5 + 1;
        this.speedX = Math.random() * 1 - 0.5;
        this.speedY = Math.random() * 1 - 0.5;
        this.color = "#0066cc";
        this.opacity = Math.random() * 0.5 + 0.1;
      }

      update() {
        this.x += this.speedX;
        this.y += this.speedY;

        if (this.x < 0 || this.x > canvas.width) {
          this.speedX = -this.speedX;
        }

        if (this.y < 0 || this.y > canvas.height) {
          this.speedY = -this.speedY;
        }
      }

      draw() {
        ctx.fillStyle = this.color;
        ctx.globalAlpha = this.opacity;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
      }
    }

    // Create particles
    const particles = [];
    const particleCount = Math.min(100, Math.floor(window.innerWidth / 20));

    for (let i = 0; i < particleCount; i++) {
      particles.push(new Particle());
    }

    // Animation loop
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Draw connections
      ctx.globalAlpha = 0.2;
      ctx.strokeStyle = "#0066cc";
      ctx.lineWidth = 0.5;

      for (let i = 0; i < particles.length; i++) {
        for (let j = i; j < particles.length; j++) {
          const dx = particles[i].x - particles[j].x;
          const dy = particles[i].y - particles[j].y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < 150) {
            ctx.beginPath();
            ctx.moveTo(particles[i].x, particles[i].y);
            ctx.lineTo(particles[j].x, particles[j].y);
            ctx.stroke();
          }
        }
      }

      // Update and draw particles
      for (let i = 0; i < particles.length; i++) {
        particles[i].update();
        particles[i].draw();
      }

      animationFrameId = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener("resize", handleResize);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <div className="hero">
      <canvas ref={canvasRef} className="hero-canvas"></canvas>
      <div className="container hero-content">
        <div className="hero-text">
          <h1>Complete Packaging Solutions</h1>
          <p className="hero-subtitle">
            Innovative metal packaging for every industry. From easy open ends
            to custom tin cans, we deliver quality, precision, and reliability.
          </p>
          <div className="hero-cta">
            <a href="#products" className="btn">
              Explore Products
            </a>
            <a href="#contact" className="btn btn-outline">
              Get a Quote
            </a>
          </div>
        </div>
        <div className="hero-image">
          <div className="hero-image-container">
            <div
              className="floating-can can-1"
              style={{
                backgroundImage: `url(${can1})`,
              }}
            ></div>
            <div
              className="floating-can can-2"
              style={{
                backgroundImage: `url(${can2})`,
              }}
            ></div>
            <div
              className="floating-can can-3"
              style={{
                backgroundImage: `url(${can3})`,
              }}
            ></div>
            <div
              className="hero-image-main"
              style={{
                backgroundImage: `url(${images[currentIndex]})`,
              }}
            ></div>
          </div>
        </div>
      </div>
      {/* <div className="hero-scroll">
        <div className="scroll-indicator"></div>
        <span>Scroll to explore</span>
      </div> */}
    </div>
  );
};

export default Hero;
